var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoM = function SvgLogoM(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg290",
    viewBox: "0 0 260 260",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs218"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 132.65,
    x2: 132.65,
    y1: 88.6,
    y2: 146.28,
    gradientTransform: "translate(-117.305 22.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop17",
    offset: 0.1,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop19",
    offset: 0.15,
    stopColor: "#231f20",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop21",
    offset: 0.21,
    stopColor: "#231f20",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop23",
    offset: 0.26,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop25",
    offset: 0.5,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop27",
    offset: 0.63,
    stopColor: "#231f20",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop29",
    offset: 0.77,
    stopColor: "#231f20",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 141.01,
    x2: 141.87,
    y1: 155.48,
    y2: 117.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop32",
    offset: 0.03,
    stopColor: "#c6cdc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop34",
    offset: 0.21,
    stopColor: "#c6cdc9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop36",
    offset: 0.6,
    stopColor: "#c6cdc9",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop38",
    offset: 0.87,
    stopColor: "#c6cdc9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop40",
    offset: 1,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 221.4,
    x2: 175.81,
    y1: 51.04,
    y2: 124.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop66",
    offset: 0,
    stopColor: "#392726"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop68",
    offset: 0.24,
    stopColor: "#392726",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    offset: 0.54,
    stopColor: "#392726",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    offset: 0.87,
    stopColor: "#392726",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop74",
    offset: 1,
    stopColor: "#392726",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-3",
    id: "linear-gradient-4",
    x1: 339.83,
    x2: 289.65,
    y1: 1.21,
    y2: 81.65,
    gradientTransform: "translate(-117.305 22.465)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 125.5,
    x2: 158.47,
    y1: 117.53,
    y2: 150.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop104",
    offset: 0.18,
    stopColor: "#c6cdc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop106",
    offset: 0.25,
    stopColor: "#c6cdc9",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop108",
    offset: 0.38,
    stopColor: "#c6cdc9",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop110",
    offset: 0.57,
    stopColor: "#c6cdc9",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop112",
    offset: 0.79,
    stopColor: "#c6cdc9",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop114",
    offset: 0.8,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 126.27,
    x2: 168.83,
    y1: 113.59,
    y2: 164.31,
    gradientTransform: "translate(-117.305 22.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop117",
    offset: 0.01,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop119",
    offset: 0.05,
    stopColor: "#c6cdc9",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop121",
    offset: 0.1,
    stopColor: "#c6cdc9",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop123",
    offset: 0.16,
    stopColor: "#c6cdc9",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop125",
    offset: 0.21,
    stopColor: "#c6cdc9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop127",
    offset: 0.27,
    stopColor: "#c6cdc9",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop129",
    offset: 0.31,
    stopColor: "#c6cdc9",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop131",
    offset: 0.36,
    stopColor: "#c6cdc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop133",
    offset: 0.46,
    stopColor: "#c6cdc9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop135",
    offset: 0.56,
    stopColor: "#c6cdc9",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop137",
    offset: 0.66,
    stopColor: "#c6cdc9",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop139",
    offset: 0.75,
    stopColor: "#c6cdc9",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop141",
    offset: 0.83,
    stopColor: "#c6cdc9",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop143",
    offset: 0.88,
    stopColor: "#c6cdc9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 181.16,
    x2: 250.11,
    y1: 104.81,
    y2: 186.98,
    gradientTransform: "translate(-117.305 22.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop169",
    offset: 0,
    stopColor: "#a3bfd9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop171",
    offset: 0.02,
    stopColor: "#a3bfd9",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop173",
    offset: 0.1,
    stopColor: "#a3bfd9",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop175",
    offset: 0.17,
    stopColor: "#a3bfd9",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop177",
    offset: 0.24,
    stopColor: "#a3bfd9",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop179",
    offset: 0.31,
    stopColor: "#a3bfd9",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop181",
    offset: 0.37,
    stopColor: "#a3bfd9",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop183",
    offset: 0.41,
    stopColor: "#a3bfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop185",
    offset: 0.53,
    stopColor: "#a3bfd9",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop187",
    offset: 0.69,
    stopColor: "#a3bfd9",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop189",
    offset: 0.84,
    stopColor: "#a3bfd9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop191",
    offset: 0.94,
    stopColor: "#a3bfd9",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop193",
    offset: 1,
    stopColor: "#a3bfd9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 294.12,
    x2: 343.18,
    y1: 84.01,
    y2: 218.79,
    gradientTransform: "translate(-117.305 22.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop197",
    offset: 0.11,
    stopColor: "#a3bfd9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop199",
    offset: 0.13,
    stopColor: "#a3bfd9",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop201",
    offset: 0.26,
    stopColor: "#a3bfd9",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop203",
    offset: 0.37,
    stopColor: "#a3bfd9",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop205",
    offset: 0.45,
    stopColor: "#a3bfd9",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop207",
    offset: 0.49,
    stopColor: "#a3bfd9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop209",
    offset: 0.66,
    stopColor: "#a3bfd9",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop211",
    offset: 0.82,
    stopColor: "#a3bfd9",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop213",
    offset: 0.94,
    stopColor: "#a3bfd9",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop215",
    offset: 1,
    stopColor: "#a3bfd9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linear-gradient-3",
    id: "linearGradient517",
    x1: 221.4,
    x2: 175.81,
    y1: 51.04,
    y2: 124.01,
    gradientTransform: "translate(-117.305 22.465)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 131.64,
    cy: 150.59,
    r: 53.99,
    gradientTransform: "translate(-117.305 22.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    offset: 0.05,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6",
    offset: 0.31,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop8",
    offset: 0.64,
    stopColor: "#4694bc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop10",
    offset: 0.65,
    stopColor: "#4899c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop12",
    offset: 0.86,
    stopColor: "#4899c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop14",
    offset: 1,
    stopColor: "#c6cdc9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 559.78,
    cy: 148.07,
    r: 100.12,
    gradientTransform: "matrix(.54 -.97 .57 .15 -363.955 691.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop43",
    offset: 0,
    stopColor: "#f2c03e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop45",
    offset: 0.06,
    stopColor: "#f0b73a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop47",
    offset: 0.17,
    stopColor: "#e99e31"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop49",
    offset: 0.3,
    stopColor: "#df7621"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop51",
    offset: 0.45,
    stopColor: "#d13e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop53",
    offset: 0.52,
    stopColor: "#ca2100"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop55",
    offset: 0.57,
    stopColor: "#bd1f00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop57",
    offset: 0.67,
    stopColor: "#9c1900"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop59",
    offset: 0.8,
    stopColor: "#651000"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop61",
    offset: 0.95,
    stopColor: "#1b0400"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop63",
    offset: 1,
    stopColor: "#010000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 236,
    cy: 164.14,
    r: 152.04,
    gradientTransform: "matrix(.15143 -.98847 .67216 .10297 -26.825 403.065)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop77",
    offset: 0.19,
    stopColor: "#f2c03e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop79",
    offset: 0.32,
    stopColor: "#e68f2b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop81",
    offset: 0.59,
    stopColor: "#ca2100"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop83",
    offset: 0.63,
    stopColor: "#c11f00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop85",
    offset: 0.7,
    stopColor: "#a81b00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop87",
    offset: 0.79,
    stopColor: "#801500"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop89",
    offset: 0.89,
    stopColor: "#480c00"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop91",
    offset: 1,
    stopColor: "#010000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 233.97,
    cy: 183.41,
    r: 82.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop94",
    offset: 0.03,
    stopColor: "#edcb48"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop96",
    offset: 0.3,
    stopColor: "#edcb48",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop98",
    offset: 0.94,
    stopColor: "#edcb48",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop100",
    offset: 1,
    stopColor: "#edcb48",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 661.03,
    cy: 183.38,
    r: 131.28,
    gradientTransform: "matrix(.58 -.96 .68 .22 -277.89 775.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop146",
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop148",
    offset: 0.25,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop150",
    offset: 0.27,
    stopColor: "#26282c"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop152",
    offset: 0.32,
    stopColor: "#304a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop154",
    offset: 0.37,
    stopColor: "#396780"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop156",
    offset: 0.43,
    stopColor: "#3f7d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop158",
    offset: 0.48,
    stopColor: "#448cb2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop160",
    offset: 0.53,
    stopColor: "#4796bf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop162",
    offset: 0.57,
    stopColor: "#4899c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop164",
    offset: 0.83,
    stopColor: "#4899c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop166",
    offset: 1,
    stopColor: "#c6cdc9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#radial-gradient-5",
    id: "radial-gradient-6",
    cx: -1326,
    cy: 1549.8,
    r: 192.89,
    gradientTransform: "matrix(.31 -.96 .74 .25 -517.635 -1430.155)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#radial-gradient-5",
    id: "radialGradient515",
    cx: 661.03,
    cy: 183.38,
    r: 131.28,
    gradientTransform: "matrix(.58 -.96 .68 .22 -395.195 798.325)",
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_lockups",
    "data-name": "logo lockups"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M29.005 116.835c-17.75-1.48-28.09 13.4-28.09 28.17v2.23c.06 1.27.16 2.51.31 3.73.07.55.15 1.11.25 1.65 2 6.68 6.51 10.52 12.58 10.52 8.8 0 19.39-8.57 27-21.85 1-1.71 2-3.54 3-5.45 1-1.91 2.65-5.19 4.35-8.61-3.71-5.42-9.27-9.55-19.4-10.39z",
    style: {
      fill: "url(#radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "M22.815 117.005a24.57 24.57 0 0 0-13.17 8.4c-5.77 7.19-8.83 19.17-3.51 27.45a11.36 11.36 0 0 0 10.17 5.21c2.22-.07 8.91-.7 13.48-3-5.09 4.7-12.71 9.5-19.9 6.87-6-2.19-8.31-8.78-8.91-14.62q-.06-1.14-.06-2.31c0-12.96 7.96-26 21.9-28z",
    style: {
      fill: "url(#linear-gradient)",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g260",
    style: {
      opacity: 0.65
    },
    transform: "translate(-117.305 22.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "M118.79 130c2 6.75 6.52 10.63 12.62 10.63 8.8 0 19.39-8.57 27-21.85 1-1.71 2-3.54 3-5.45.93-1.74 2.57-5 4.23-8.36-.12-.13-.25-.25-.38-.38a11.79 11.79 0 0 0-16.35-.52c-9.08 8.66-4.05 30.85-19.28 32.29-8.42.79-10.8-6.13-11.36-11.82v.19a47.26 47.26 0 0 0 .52 5.27z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    d: "M93.955 108.845c1.12-13.3.07-20.94-3.43-24.76a9 9 0 0 0-6.92-2.81c-4.68 0-9.15 2.37-13.76 7.3-2.54 3.36-5 7-7.27 10.74-1.83 3-8.24 14.86-9.67 17.75-.84 1.71-7.07 14.45-9.24 18.54q-1.5 2.83-3 5.44c-7.61 13.29-18 21.6-26.57 21.6-7.18 0-12.14-5.51-13.14-15.41.84 19.23 12.4 33.43 33.74 33.43a44 44 0 0 0 17-3.39c12.72-5.31 23-16.47 31.66-30.26 2.15-3.3 4.31-7.06 6.5-11.18.17-.32.48-.93.9-1.76q.84-5.7 1.67-11.68c.72-5.44 1.21-9.75 1.53-13.55z",
    style: {
      fill: "url(#radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    d: "M93.955 108.845c1.12-13.3.07-20.94-3.43-24.76a9 9 0 0 0-6.92-2.81c-4.67 0-9.13 2.36-13.73 7.27q-1.29 1.69-2.53 3.46c5.48-6.6 10.26-9.88 16.16-9.22 8 .9 7.66 15.89 3.45 34.15-1.07 4.63-2.36 9.64-3.81 15-2.46 9-4.92 17.55-7.12 25.52a120.11 120.11 0 0 0 7.31-10.41c2.15-3.3 4.31-7.06 6.5-11.18.17-.32.48-.93.9-1.76q.84-5.7 1.67-11.68c.74-5.47 1.23-9.78 1.55-13.58z",
    style: {
      fill: "url(#linearGradient517)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M197.485 42.655a10.15 10.15 0 0 0-7.89-3.34c-5.16 0-10.48 2.95-15.36 8.4a84.07 84.07 0 0 0-5.54 8.75c-11.71 21.3-20.3 42.1-31.06 66.26-.57 4.13-1.16 8.11-1.8 12.5l-.09.62c-1.45 9.86-2.82 19.16-3.49 27-1.13 13.32-.07 21 3.43 24.77a9 9 0 0 0 7 2.81c4.75 0 9.38-2.43 14-7.38 2.27-3 4.44-6.23 6.52-9.59a422.07 422.07 0 0 0 33.76-68.58c1-8.57 1.79-15.89 2.47-21.84.83-7.32 1.42-12.6 1.82-16.25 1.32-11.76.04-19.88-3.77-24.13z",
    style: {
      fill: "url(#radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g270",
    style: {
      opacity: 0.9
    },
    transform: "translate(-117.305 22.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path268",
    d: "M253.08 113.37c-1.45 9.86-2.82 19.16-3.49 27-1.13 13.32-.07 21 3.43 24.77a9 9 0 0 0 7 2.81c4.74 0 9.36-2.42 14-7.34l1.46-2c-4.61 3.81-10.95 7.56-15.51 3.41-7.84-7.14-2.47-35.15-.62-50.26.73-5.94 2.16-17.57 3.76-30-2.62 6-5.3 12.07-8.12 18.41-.57 4.13-1.16 8.11-1.8 12.5z",
    style: {
      fill: "url(#radial-gradient-4)",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M201.295 66.805c1.28-11.78 0-19.9-3.81-24.15a10.15 10.15 0 0 0-7.89-3.34c-5.16 0-10.48 2.95-15.37 8.4l-.93 1.32c7-7.58 11.79-9.37 16.57-8.3 7.53 1.68 9.06 14.39 4 34.53-2.39 9.54-7.63 30-15.54 61.43q-2.52 10-4.89 19.17a441.11 441.11 0 0 0 23.54-51c1-8.57 1.79-15.89 2.47-21.84.86-7.29 1.45-12.56 1.85-16.22z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g276",
    style: {
      opacity: 0.6
    },
    transform: "translate(-117.305 22.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path274",
    d: "M152 158.2c-5.08-.43-10.94-2.65-12.47-7.37-2.52-7.8 7.16-13.34 17.59-30.87-7.52 12.48-17.46 20.22-25.75 20.22-7.19 0-12.15-5.52-13.14-15.42.86 19.24 12.43 33.44 33.77 33.44z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    d: "M1.055 148.565c0 .33 0 .65.07 1 1.62 18 13.1 31.13 33.61 31.13 11.7 0 21.62-4.4 30.24-11.65-6.25 4-12.83 7.11-19.75 8.47a48 48 0 0 1-10.48.92 45.45 45.45 0 0 1-10.27-1.48 29.29 29.29 0 0 1-9.12-4.4 27.65 27.65 0 0 1-7.08-7.34c-5.64-8.57-6.88-13.69-7.31-17.92v.83c0 .28.07.34.09.44z",
    style: {
      fill: "url(#linear-gradient-6)",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    d: "M160.895 177.155c-5.75 8.07-11.72 12.8-18.22 12.8-9.71 0-11.29-10.63-9.9-27.05.68-8 2.07-17.41 3.57-27.62.62-4.19 1.26-8.52 1.87-13 .65-4.83 1.77-16.59 1.85-17.94 1.27-22.93-2.93-40.64-27.79-40.64-20.41 0-35.33 13.38-47.41 31.93 6-8.7 12-13.88 18.74-13.91 9.67 0 11.24 10.65 9.86 27-.35 4.17-.89 8.69-1.54 13.52-2.1 15.23-4.48 29.28-5.44 40.58 0 0-.27 3.83-.37 5.76-1.06 22.06 3.17 39.3 27.55 39.3 20.42.08 35.29-12.68 47.23-30.73z",
    style: {
      fill: "url(#radialGradient515)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    d: "M115.915 207.905c1.29-.06 2.55-.17 3.82-.33 11.77-1.54 21.58-7.53 30-16.29l-.24.22a62.3 62.3 0 0 1-8.71 6.43 50.88 50.88 0 0 1-22 7.5c-7.78.73-16.62.17-22.74-5.27-5.81-5.17-7.6-13.43-8.21-20.85-.66-8.1 0-16.24.78-24.31q1.25-12.84 2.35-25.7c-1.81 12.53-3.63 24-4.45 33.6 0 0-.27 3.83-.37 5.76-1.06 22.06 3.17 39.3 27.55 39.3q1.1 0 2.22-.06z",
    style: {
      fill: "url(#linear-gradient-7)",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    d: "M258.895 215.995a.76.76 0 0 0-1 .1 14.47 14.47 0 0 1-9.07 3.4c-8.53 0-12.47-10.78-12.12-28.6.48-24.18 10.44-100.52 12.87-126.79 2.24-23.99-4.88-41.64-30.53-41.64-14.41 0-34 7-48.38 30.65 5.64-8.37 12.29-13.31 18.93-13.31 8.94 0 13.19 8.78 11.21 27-.93 8.61-3.08 27.1-6.22 55.45-3.35 30.21-6.83 53.83-6.89 70.21-.77 25 6.15 45.07 33 45.07 16.12 0 29.29-8.7 38.15-20.43a.83.83 0 0 0 .05-1.11z",
    style: {
      fill: "url(#radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    d: "M238.885 232.465c-10.82 4-24.53 5-34.72-1.31-10.19-6.31-13.2-18.74-14.1-29.93-1-12.52.51-25.29 1.47-37.76l1.29-16.87 1.76-23 .27-3.88q-.14 1.23-.27 2.49c-3.35 30.26-6.83 53.88-6.89 70.26-.77 25 6.15 45.07 33 45.07a44.59 44.59 0 0 0 27-9.27 56.33 56.33 0 0 1-8.81 4.2z",
    style: {
      fill: "url(#linear-gradient-8)",
      opacity: 0.25
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoM);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logo-m.9faadc9.svg";